import React from "react";
import styles from "./Layout.module.scss";
import BrandLogo from "~/components/BrandLogo/BrandLogo";

const Layout: React.FC<React.ComponentPropsWithoutRef<"div">> = ({
  children,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <BrandLogo className={styles.logo} />
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default Layout;
